import React, { useEffect, useRef } from "react";
import { docExtensions, pdfExtensions } from "../../const/FileExtensions";
import ShowToast from "../../widget/common/ui/Toast";
import AppTranslation from "../app_translation/AppTranslation";
import { useDispatch } from "react-redux";
import { addModal } from "../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../const/ModalKeys";
import {
  appplyActionDocument,
  provideDocumentDetail,
} from "../../libraries/state_reducers/service/FileDocumentPickerReducer";
import { useSelector } from "react-redux";
import { RootState } from "../../libraries/state_reducers/store";
import { ResponsiveDeviceType } from "../../widget/layouts/ScreenMedia";

type FileDocumentPickerType = {
  children: React.ReactNode;
  fromAction: string;
  callback: (file: File | null) => void;
  onClick: () => void;
};

const FileDocumentPicker: React.FC<FileDocumentPickerType> = ({
  children,
  fromAction = "",
  callback,
  onClick,
}) => {
  const dispatch = useDispatch();
  const type: number = ResponsiveDeviceType();
  const inputRef = useRef<HTMLInputElement>(null);
  const fileRef = useRef<File | null>(null);

  const combineExtensions: Array<string> = [...pdfExtensions, ...docExtensions];
  let FileExtensions: Array<string> = [];

  combineExtensions.forEach((ext) => {
    FileExtensions.push(`.${ext}`);
  });

  const appplyActionStatusSelector = useSelector(
    (state: RootState) => state.fileDocumentPicker.appplyActionStatus
  );

  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    fileRef.current = file;
    const ext = file.type.split("/").pop()?.toLowerCase();
    /* console.log(file.type);
    console.log(combineExtensions);
    console.log(ext); */
    if (combineExtensions.includes(ext!)) {
      dispatch(
        provideDocumentDetail({
          fileString: URL.createObjectURL(file),
          fileName: file.name,
          fromAction: fromAction,
        })
      );
      dispatch(
        addModal({
          id: ModalKeys.file_document_viewer,
          size: "lg",
          screenMobileView: type === 3 ? false : true,
        })
      );

      if (inputRef.current) {
        inputRef.current.value = "";
      }
    } else {
      ShowToast.error(AppTranslation.text("invalid_file_type"));
    }
  };

  useEffect(() => {
    if (appplyActionStatusSelector && typeof callback === "function") {
      callback(fileRef.current!);
    }

    return () => {
      dispatch(appplyActionDocument(false));
    };
    // eslint-disable-next-line
  }, [appplyActionStatusSelector]);

  useEffect(() => {
    return () => {
      fileRef.current = null;
    };
  }, []);

  return (
    <div className="file-editor-picker">
      <input
        ref={inputRef}
        type="file"
        accept={FileExtensions.join(",")}
        onChange={handleFile}
      />
      {children}
    </div>
  );
};

export default FileDocumentPicker;
